import LinkWithIcon from './LinkWithIcon'

export default LinkWithIcon
